<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="3">
            <v-text-field
              label="Nome do Profissional"
              v-model="form.filters.nome"
              outlined
              dense
              hide-details
              @keyup.enter="buscarProfissionais"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              label="Função"
              v-model="form.filters.funcao"
              outlined
              dense
              hide-details
              @keyup.enter="buscarProfissionais"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              label="CPF"
              v-model="form.filters.cpf"
              v-mask="'###.###.###-##'"
              maxlength="14"
              outlined
              dense
              v-only-number
              hide-details
              @keyup.enter="buscarProfissionais"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="3">
            <v-select
              label="GRE"
              v-model="form.filters.greId"
              outlined
              dense
              hide-details
              :items="form.lists.listGres"
              item-text="nome"
              item-value="id"
            ></v-select>
          </v-col>
          <v-col cols="3">
            <v-autocomplete
              id="lotacao"
              label="Lotação"
              :items="form.lists.listLotacoes"
              :item-text="'local'"
              :item-value="'id'"
              v-model="form.filters.lotacaoId"
              outlined
              dense
            />
          </v-col>
          <sca-select-ativo
            :cols="3"
            :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo', label: 'Situação' }"
            v-model="form.filters.ativo"
          ></sca-select-ativo>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sca-tooltip
              :text="'Buscar'"
              :icon="'mdi-magnify'"
              @click="buscarProfissionais()"
            ></sca-tooltip>
            <sca-tooltip
              :text="'Limpar'"
              :icon="'mdi-eraser'"
              @click="resetForm()"
            ></sca-tooltip>
            <sca-tooltip
              :text="'Incluir'"
              :icon="'mdi-plus'"
              @click="openDialogManterProfissional()"
            ></sca-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5"
        :headers="table.headers"
        :items="table.itens"
        :items-per-page="10"
        :footer-props="$footerProps"
        :no-data-text="'Não há registros a serem exibidos.'"
      >
        <template v-slot:[`item.nome`]="{ item }">
          <span>{{ item.nome }}</span>
        </template>
        <template v-slot:[`item.cpf`]="{ item }">
          <span>{{ $formatCpf(item.cpf) }}</span>
        </template>
        <template v-slot:[`item.funcao`]="{ item }">
          <span>{{ item.funcao }}</span>
        </template>
        <template v-slot:[`item.gre`]="{ item }">
          <span>{{ item.gre }}</span>
        </template>
        <template v-slot:[`item.lotacao`]="{ item }">
          <span>{{ item.lotacao }}</span>
        </template>
        <template v-slot:[`item.ativo`]="{ item }">
          <sca-label-ativo :ativo="item.ativo" :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo' }"></sca-label-ativo>
        </template>
        <template v-slot:[`item.acoes`]="{ item }">
          <sca-tooltip
            :text="'Visualizar'"
            :icon="'mdi-eye-outline'"
            :small="true"
            @click="openDialogVisualizarProfissional(item)"
          ></sca-tooltip>
          <sca-tooltip
            :text="'Editar'"
            :icon="'mdi-pencil'"
            :small="true"
            @click="openDialogManterProfissional(item)"
          ></sca-tooltip>
          <sca-tooltip
            :text="`${item.ativo ? 'Inativar' : 'Ativar'}`"
            :icon="`${item.ativo ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'}`"
            :small="true"
            @click="inativarAtivarProfissional(item)"
          ></sca-tooltip>
        </template>
      </v-data-table>
    </v-container>
    <CadastrarEditarProfissionalDialog
      :visible="dialogManterProfissional.visible"
      :content="dialogManterProfissional.content"
      :edit="dialogManterProfissional.edit"
      @onClose="dialogManterProfissional.close()"
      @onSave="buscarProfissionais()"
    ></CadastrarEditarProfissionalDialog>
    <VisualizarProfissionalDialog
      v-if="dialogVisualizarProfissional.visible"
      :visible="dialogVisualizarProfissional.visible"
      :content="dialogVisualizarProfissional.content"
      @onClose="dialogVisualizarProfissional.close()"
    ></VisualizarProfissionalDialog>
  </div>
</template>

<script>
import { Dialog } from '~/commons/classes/dialog';
import { Profissional } from '~/commons/classes/profissional';
import ProfissionalService from '~/services/profissional.service';
import GreMunicipioService from '~/services/gre-municipio.service';
import PreLoginService from "~/services/pre-login.service";
import LotacaoService from "~/services/lotacao.service";
import DataTablesMixin from '~/mixins/datatables.mixin';
import CadastrarEditarProfissionalDialog from "./dialogs/CadastrarEditarProfissionalDialog.vue";
import VisualizarProfissionalDialog from "./dialogs/VisualizarProfissionalDialog.vue";

export default {
  name: "ManterProfissionalView",
  mixins: [
    ProfissionalService,
    DataTablesMixin,
    GreMunicipioService,
    PreLoginService,
    LotacaoService
  ],
  components: {
    CadastrarEditarProfissionalDialog,
    VisualizarProfissionalDialog,
  },
  data: () => ({
    dialogManterProfissional: Dialog.Build(),
    dialogVisualizarProfissional: Dialog.Build(),
    form: {
      filters: {
        nome: null,
        funcao: null,
        cpf: null,
        greId: null,
        lotacaoId: null,
        ativo: null,
      },
      lists: {
        listGres: [],
        listLotacoes: [],
      }
    },
    table: {
      headers: [
        { text: 'Nome do Profissional', align: 'center', value: 'nome' },
        { text: 'CPF', align: 'center', value: 'cpf' },
        { text: 'Função', align: 'center', value: 'funcao' },
        { text: 'GRE', align: 'center', value: 'gre' },
        { text: 'Lotação', align: 'center', value: 'lotacao' },
        { text: 'Situação', align: 'center', value: 'ativo' },
        { text: 'Ações', align: 'center', value: 'acoes', sortable: false },
      ],
      itens: [],
    },
  }),
  watch: {
    "form.filters.greId": function(value) {
      if (value) {
        this.form.filters.lotacaoId = null;
        this.buscarLotacoes(value);
      }
    },
  },
  methods: {
    buscarLotacoes(value) {
      this.$buscarLotacoes({ params: { gres: value } }).then(({ data }) => (this.form.lists.listLotacoes = data.resposta));
    },
    buscarMunicipios() {
      this.$buscarGreMunicipios().then(({ data }) => (this.form.lists.listGres = data.resposta.gres));
    },
    buscarProfissionais() {
      if (this.$validarFormulario()) {
        const params = {
          ...this.form.filters,
          cpf: this.$unMask(this.form.filters.cpf),
        }
        this.$buscarProfissionais({ params }).then(({ data }) =>
          (this.table.itens = data.itens))
      }
    },
    openDialogManterProfissional(profissional) {
      profissional
        ? this.$visualizarProfissionais({id: profissional.id}).then(({ data }) =>
          this.dialogManterProfissional.open(new Profissional(data.resposta).formatParaEditar(data.resposta), true))
        : this.dialogManterProfissional.open(Profissional.Build());
    },
    openDialogVisualizarProfissional(profissional) {
      this.$visualizarProfissionais({id: profissional.id}).then(({ data }) =>
        this.dialogVisualizarProfissional.open(new Profissional(data.resposta).formatParaVisualizar(data.resposta)));
    },
    inativarAtivarProfissional(profissional) {
      this.$swal({
        text: `Deseja ${profissional.ativo ? "inativar" : "ativar"} o registro?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      }).then(() => {
        this.$inativarAtivarProfissional(profissional.id).then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.buscarProfissionais();
        });
      });
    },
    resetForm() {
      this.$resetForm();
      this.table.itens = [];
      this.form.filters.nome = null;
      this.form.filters.funcao = null;
      this.form.filters.cpf = null;
      this.form.filters.greId = null;
      this.form.filters.lotacaoId = null;
      this.form.filters.ativo = null;
    },
  },
  mounted() {
    this.buscarMunicipios();
    this.buscarLotacoes();
  },
};
</script>
